import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'

const PaginationComponent = ({ page, totalRecords, recordsPerPage, handlePageChange }) => {
    const totalPages = Math.ceil(totalRecords / recordsPerPage);
    const startRecord = totalRecords > 0 ? (page - 1) * recordsPerPage + 1 : 0;
    const endRecord = totalRecords > 0 ? Math.min(startRecord + recordsPerPage - 1, totalRecords) : 0;

    const startPage = Math.max(1, page - 2);
    const endPage = Math.min(totalPages, startPage + 4);

    return (
        <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
            <div className="flex flex-1 justify-between sm:hidden">
                <button
                    onClick={() => handlePageChange(page - 1)}
                    disabled={page <= 1}
                    className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
                    Previous
                </button>
                <button
                    onClick={() => handlePageChange(page + 1)}
                    disabled={page >= totalPages}
                    className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
                    Next
                </button>
            </div>
            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                <div>
                    <p className="text-sm text-gray-700">
                        {totalRecords > 0 ? (
                            <>
                                Viewing <span className="font-medium">{startRecord}</span> - <span className="font-medium">{endRecord}</span> of <span className="font-medium">{totalRecords}</span> results
                            </>
                        ) : (
                            "No results found"
                        )}
                    </p>
                </div>
                <div>
                    <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                        <button
                            onClick={() => handlePageChange(page - 1)}
                            disabled={page <= 1}
                            className={`relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${page <= 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
                            aria-label="Previous">
                            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                        </button>

                        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
                            .map(p => (
                                <button
                                    key={p}
                                    onClick={() => handlePageChange(p)}
                                    className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${page === p ? 'bg-blue-500 hover:bg-blue-400 text-white' : 'text-gray-900 hover:bg-gray-50'} ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                                >
                                    {p}
                                </button>
                            ))}

                        <button
                            onClick={() => handlePageChange(page + 1)}
                            disabled={page >= totalPages}
                            className={`relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${page >= totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
                            aria-label="Next">
                            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default PaginationComponent;
